import React from "react";
import { useIntl } from "react-intl";

import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import getGenders from "./utils/getGenders";

export default function AudienceGenderSelect({
  selectedAudienceGender,
  onChangeAudienceGender,
  isDisabled,
}) {
  const intl = useIntl();
  const genders = getGenders(intl);

  const foundOption = genders.find(
    (gender) => gender.value === selectedAudienceGender?.value,
  );

  return (
    <div className="audience-search__field">
      <div className="idh-label idh-label--with-tooltip">
        <IDHFormattedMessage id="front_gender" defaultMessage="Gender" />
        <MaterialTooltip
          id="front_gender_tooltip"
          content={
            <IDHFormattedMessage
              id="front_gender_tooltip"
              defaultMessage="Discover best influencers by their audience gender. Select gender and % density for this gender group among influencers."
            />
          }
        />
      </div>
      <CustomSelect
        placeholder={intl.formatMessage({
          id: "front_select_gender",
          defaultMessage: "Select",
        })}
        isClearable
        value={foundOption}
        options={genders}
        onChange={(option) => {
          if (option) {
            onChangeAudienceGender({ value: option.value });
          } else {
            onChangeAudienceGender(option);
          }
        }}
        isDisabled={isDisabled}
        dataAttr="audience-gender"
      />
    </div>
  );
}
